<template>
  <g>
    <popover
       v-if="!noPopover && (alwaysPopover || ellipsed)"
       :content="text"
       :delay="100"
       :hideDelay="100" >
      <text ref="text" :x="x" :y="y" :dx="dx" :dy="dy" :text-anchor="textAnchor" :fill="fill" >
        {{ ellipsis + (ellipsed ? '...' : '') }}
      </text>
    </popover>
    <text v-else ref="text" :x="x" :y="y" :dx="dx" :dy="dy" :text-anchor="textAnchor" :fill="fill" >
      {{ ellipsis + (ellipsed ? '...' : '') }}
    </text>
  </g>
</template>

<script>
import Popover from './Popover.vue'

export default {
  components: {
    Popover: Popover
  },
  props: {
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    fill: {
      type: String
    },
    dx: {
      type: [Number, String],
      default: 0
    },
    dy: {
      type: [Number, String],
      default: 0
    },
    textAnchor: {
      type: String,
      default: 'inherit'
    },
    text: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    alwaysPopover: {
      type: Boolean,
      default: true
    },
    noPopover: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ellipsis: this.text,
      destroyed: false
    }
  },
  mounted () {
    this.shrink()
    window.addEventListener('resize', this.reShrink)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.reShrink)
    this.destroyed = true
  },
  watch: {
    text () {
      this.ellipsis = this.text
      this.shrink()
    },
    width () {
      this.ellipsis = this.text
      this.shrink()
    }
  },
  computed: {
    ellipsed () {
      return this.ellipsis.length < this.text.length
    }
  },
  methods: {
    reShrink () {
      this.ellipsis = this.text
      this.shrink()
    },
    shrink () {
      if (this.destroyed) {
        return
      }
      this.$nextTick(() => {
        if (this.destroyed) {
          return
        }
        if (!this.$refs.text) {
          return this.shrink()
        }
        if (this.$refs.text.getComputedTextLength() > this.width && this.ellipsis.length) {
          this.ellipsis = this.ellipsis.slice(0, -1)
          this.shrink()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Ellipsis.vue